'use strict'
import { codeMasterType } from "../../../../config/constants";
import ViewBase from "../../../view-base.view";
import { Spinner, Button, Icons } from 'construct-ui'
import codeMasterModel from "../../../../models/common/code-master.model";
import textInputComponent from "../../../../components/common/text-input.component";
import dropdownInputComponent from "../../../../components/common/dropdown-input.component";
import log from "../../../../utils/logger";
import TableComponent from "../../../../components/common/table.component";
import udfManagementModel from "../../../../models/udf-management/udf-management.modal";
import '../../../../utils/extensions';

export default function UserCreateUdfFormView() {
  ViewBase.call(this);
  let _attrs;
  let _validateAll = false;
  let _udfData = [];
  let _countryList = [];
  let _udfAttributeAllList = [];
  let _udfAttributeList = [];
  let _udfValueAllList = [];
  let _udfValueList = [];
  let _udfForm = {
    countryCode: '',
    countryName: '',
    attributeId: '',
    attributeName: '',
    valueId: '',
    valueName: '',
    type: ''
  };
  let isLoading = false;
  let isLoaded = false;

  let saveForm = () => {
    _attrs.submit(_udfData, true);
  }

  let _getAttributeType = () => {
    let udf = _udfAttributeList.getByCode(_udfForm.attributeId);
    if (udf) {
      return udf.type;
    }
    return '';
  }

  let _setAttributeValueOptions = () => {
    let _values = _udfValueAllList.filter(v => v.attributeId === _udfForm.attributeId);
    let _options = _values;
    const empty = {
      attributeId: '',
      code: '',
      name: 'Choose...',
    }
    _options.unshift(empty);
    _udfValueList = _options;
  }

  let addToList = () => {
    _validateAll = true;
    if (!_udfForm.countryCode || !_udfForm.attributeId || _udfForm.valueId == '') return;
    _udfForm.countryName = _countryList.getByCode(_udfForm.countryCode)?.name;

    let _udfFormCopy = { ..._udfForm };

    _udfData.push(_udfFormCopy);
    resetUdfList();
  }

  let removeFromList = (attributeId) => {
    var obj = _udfData.find(e => e.attributeId === attributeId);
    _udfData.remove(obj);
    resetUdfList();
  }

  let _countryChanged = (e) => {
    _udfForm.countryCode = _countryList[e.target.selectedIndex].code;
    setUdfList();
  }
  let _udfAttributeChanged = (e) => {
    _udfForm.attributeId = _udfAttributeList[e.target.selectedIndex].code;
    _udfForm.attributeName = _udfAttributeList[e.target.selectedIndex].name;
    _udfForm.valueId = '';
    _udfForm.valueName = '';
    _setAttributeValueOptions();
  }
  let _udfValueChanged = (e) => {
    if (_getAttributeType() == 'Dropdown') {
      _udfForm.valueId = _udfValueList[e.target.selectedIndex].code;
      _udfForm.valueName = _udfValueList[e.target.selectedIndex].name;
      _udfForm.type = 'Dropdown';
    } else {
      _udfForm.valueId = e.target.value;
      _udfForm.valueName = e.target.value;
      _udfForm.type = '';
    }
  }

  let setCountryList = () => {
    codeMasterModel.getByCategory(
      (result) => {
        _countryList = result;
        log.t(_countryList);
        this.state.isLoading = false;
      },
      (error) => {
        return [];
      },
      { category: codeMasterType.country, countryCode: '' }
    );
  }

  let setUdfList = () => {
    udfManagementModel.getByType(
      (result) => {
        if (result) {
          _udfAttributeAllList = result.udfAttributes.map(udf => ({ type: udf.type, code: udf.attributeId, name: udf.name }));;
          _udfAttributeAllList.unshift({ type: '', code: '', name: 'Choose...', });
          _udfValueAllList = result.udfValues.map(udf => ({ attributeId: udf.attributeId, code: udf.valueId, name: udf.name }));;;
        }
        else {
          _udfAttributeAllList = [];
          _udfValueAllList = [];
        }
        resetUdfList();
        this.state.isLoading = false;
      },
      (error) => {
        _udfAttributeAllList = [];
        _udfValueAllList = [];
      },
      { udfType: 'user', countryCode: _udfForm.countryCode }
    );
  }

  let resetUdfList = () => {
    let _newlist = _udfAttributeAllList.filterRemoveListByCode(_udfData.map(d => ({ code: d.attributeId })))
    _udfAttributeList = _newlist;
    _udfForm.attributeId = '';
    _udfForm.attributeName = '';
    _udfForm.valueId = '';
    _udfForm.valueName = '';
    _validateAll = false;
  }

  let init = () => {
    if (_attrs.defaultCountry?.countryUdfLoaded) return;
    _udfForm.countryCode = _attrs.defaultCountry?.code;
    if (_attrs.udfForm?.length > 0 && _udfData.length == 0) _udfData = _attrs.udfForm;
    setUdfList();
    _attrs.defaultCountry.countryUdfLoaded = true;
  }

  return {
    oninit: (vnode) => {
      this.initState(vnode.state);
      _attrs = vnode.attrs;
      setCountryList();
      init();
    },
    onupdate: () => {
      saveForm();
    },
    view: ({ attrs }) => {
      _attrs = attrs;
      init();
      let _selectedAttributeType = _getAttributeType();

      return [m('.row',
        m(Spinner, {
          active: isLoading,
          background: true,
          fill: true,
          size: 'xl',
        }),

        m("div", { "class": "col-md-12_" },
          m("div", { "class": "" },
            m("div",
              m("a", {
                "class": "btn btn-primary btn-search", "href": "#showUdfManagement", "data-bs-toggle": "collapse",
                "role": "button", "aria-expanded": "true", "aria-controls": "showUdfManagement"
              },
                m("span", { "class": "search-arrow me-2" },
                  [
                    m("i", { "class": "bi bi-chevron-down" })
                  ]
                ),
                this.getText("LT00000008", "UDF Management")
              )
            )
          ),

          m("div", { "class": "card_ mb-3 searchbox no-leftradius collapse show py-3", "id": "showUdfManagement" },
            m("div", { "class": "card-body_" },
              m("div", { "class": "row" },
                m("div", { "class": "" }, [
                  m('.row.mb-4',
                    m(dropdownInputComponent, {
                      label: this.getText("LT00000188", "Country"),
                      id: 'country',
                      selectedValue: _udfForm.countryCode,
                      data: _countryList,
                      onchange: (e) => { _countryChanged(e) },
                      col: 3,
                      mandatory: true,
                      validate: _validateAll,
                      isvalid: _udfForm.countryCode != '',
                      errorMessage: this.getText("LT00000261", "Country is required"),
                    }),
                    m(dropdownInputComponent, {
                      label: this.getText("LT00000262", "UDF Attribute"),
                      id: 'attribute',
                      selectedValue: _udfForm.attributeId,
                      data: _udfAttributeList,
                      onchange: (e) => { _udfAttributeChanged(e); },
                      col: 3,
                      mandatory: true,
                      validate: _validateAll,
                      isvalid: _udfForm.attributeId != '',
                      errorMessage: this.getText("EM00000308", "UDF Attribute is required"),
                    }),
                    m(`.col-md-3${_selectedAttributeType == "Dropdown" ? ".d-block" : ".d-none"}`,
                      m(dropdownInputComponent, {
                        label: this.getText("LT00000263", "UDF Value"),
                        id: 'value',
                        selectedValue: _udfForm.valueId,
                        data: _udfValueList,
                        onchange: (e) => { _udfValueChanged(e); },
                        col: 12,
                        mandatory: true,
                        validate: _validateAll,
                        isvalid: _udfForm.valueId != '',
                        errorMessage: this.getText("EM00000309", "UDF Value is required"),
                      }),
                    ),
                    m(`.col-md-3${(_selectedAttributeType === "Text" || _selectedAttributeType === "Number") ? ".d-block" : ".d-none"}`,
                      m(textInputComponent, {
                        label: this.getText("LT00000263", "UDF Value"),
                        placeholder: `${_selectedAttributeType} value`,
                        id: 'value',
                        col: 12,
                        type: _selectedAttributeType,
                        value: _udfForm.valueId,
                        mandatory: true,
                        validate: _validateAll,
                        isvalid: _udfForm.valueId != '',
                        errorMessage: this.getText("EM00000309", "UDF Value is required"),
                        onchange: (e) => { _udfValueChanged(e); },
                      }),
                    ),
                    m('.col-md-3.d-flex.align-items-end',
                      m('button.btn .btn-primary', {
                        onclick: addToList
                      }, this.getText("LT00000090", "Add"))
                    )
                  ),
                  m('div', { "class": "card no-leftradius" },
                    m('div', { "class": "card-body pt-3" },
                      m(TableComponent, {
                        isNested: false,
                        headers: [
                          { label: this.getText("LT00000188", "Country"), },
                          { label: this.getText("LT00000262", "UDF Attribute") },
                          { label: this.getText("LT00000263", "UDF Value") },
                          { label: "" },
                        ],
                        details: _udfData.map(d => [
                          m("tr",
                            m("td", { "style": { "max-width": "150px", "white-space": "initial" } }, d.countryName),
                            m("td", { "style": { "max-width": "200px", "white-space": "initial" } }, d.attributeName),
                            m("td", { "style": { "max-width": "200px", "white-space": "initial" } }, d.valueName),
                            m("td", { "class": "center" },
                              m(Button, {
                                style: 'margin: 5px',
                                iconLeft: Icons.DELETE,
                                intent: 'primary',
                                size: 'xs',
                                label: 'Remove',
                                onclick: () => removeFromList(d.attributeId)
                              })
                            )
                          )
                        ]),
                      })
                    )
                  )
                ]
                )
              )
            )
          ),// End Search Box
        ),
      ), this.getBaseViews()];
    },
  };
}
